// Generated by ReScript, PLEASE EDIT WITH CARE


function fireUnregEventIfCustNotExist(parameters, send_unregistered_event_flag) {
  
}

export {
  fireUnregEventIfCustNotExist ,
}
/* No side effect */
